import {toolState, rightCanvasData, getCanvas} from "@/modules/reader/tools/tools";
import {saveTmpCanvasData, restoreTmpCanvasData, getTouchOffset, setCanvasClientPos, checkIsOutOfCanvas} from "@/modules/utils/drawUtils";
import {updateRgbaStrOpacity, rgbaArr2Str, argbHex2rgbaArr} from "@/modules/utils/colorUtils";
import {isMultiTouch, replaceDefaultTouchBehavior, restoreDefaultTouchBehavior, setBodyPinchZoomOnly} from "@/modules/utils/touchUtils";;
import config from "@/config/config.json";
import {useTool} from "@/modules/reader/tools/tools"

let canvasElList = {}; //canvas element list
let canvasEl; //current active canvas element
let ctx; //current active canvas context
let startX;
let startY;
let touchStartViewportScale;
let touchEndViewportScale;
let history = [];

const init = (el) =>{
    canvasElList[el.id] = el;
}

const activate = (id)=> {

    if (getCanvas(id)) {
        canvasEl = getCanvas(id);
        setCanvasClientPos(canvasEl);
        canvasEl.addEventListener("mousedown", onMouseDown);
        canvasEl.addEventListener("touchstart", onMouseDown);
        canvasEl.addEventListener("mouseup", onMouseUp);
        canvasEl.addEventListener("touchend", onMouseUp);
    }
}

const deactivate = (id)=> {
    if (getCanvas(id)) {
        canvasEl = getCanvas(id);
        canvasEl.removeEventListener("mousedown", onMouseDown);
        canvasEl.removeEventListener("touchstart", onMouseDown);
        canvasEl.removeEventListener("mouseup", onMouseUp);
        canvasEl.removeEventListener("touchend", onMouseUp);
    }
}


const onMouseDown = (e)=> {

    touchStartViewportScale = window.visualViewport.scale;

    if (isMultiTouch(e)) {
        return;
    }

    e.stopPropagation();
    toolState.isUsing = true;
    canvasEl = e.target;

    //for getting canvas left top position on touch device,
    // since toggling page mode will change the canvas position, so update it again on touchstart
    setCanvasClientPos(canvasEl);

    let offsetValue =  getTouchOffset(e);
    startX = offsetValue.x;
    startY= offsetValue.y;

    useTool().closeToolBoxAndPanel();
    ctx = canvasEl.getContext("2d");
    ctx.globalCompositeOperation = "source-over";
    ctx.lineJoin = "round";
    ctx.lineCap = "round";
    ctx.lineWidth =  toolState.brushSetting.size * config.reader.maxZoom;
    ctx.setLineDash([]);
    ctx.strokeStyle = updateRgbaStrOpacity(toolState.brushSetting.color, toolState.brushSetting.opacity);
    ctx.beginPath();
    ctx.moveTo(startX,startY);

    saveTmpCanvasData(ctx);
    //history.push({x: startX / config.reader.maxZoom ,y: startY / config.reader.maxZoom})
    useTool().addHistory(history, startX, startY );
    canvasEl.addEventListener("mousemove", onMouseMove);
    canvasEl.addEventListener("touchmove", onMouseMove);
    canvasEl.addEventListener("mouseout", onMouseOut);
    canvasEl.addEventListener("touchcancel", onMouseOut);
    canvasEl.addEventListener("mouseup", onMouseUp);
    canvasEl.addEventListener("touchend", onMouseUp);

}

const onMouseUp  = (e) => {

    touchStartViewportScale = touchEndViewportScale;

    e.stopPropagation();
    canvasEl.removeEventListener("mousemove", onMouseMove);
    canvasEl.removeEventListener("touchmove", onMouseMove);
    canvasEl.removeEventListener("mouseout", onMouseOut);
    canvasEl.removeEventListener("touchcancel", onMouseOut);
    canvasEl.removeEventListener("mouseup", onMouseUp);
    canvasEl.removeEventListener("touchend", onMouseUp);

    if (isMultiTouch(e) || touchStartViewportScale !== touchEndViewportScale) {
        return;
    }

    //The digit after the last hyphen is the page index (zero based). Use this number to clone image for switching page mode
    let targetPageNum = parseInt(canvasEl.id.split("-").pop());
    let offsetValue =  getTouchOffset(e);
    let x = offsetValue.x;
    let y = offsetValue.y;

    ctx.lineTo(x,y);
    ctx.closePath();

    //history.push({x: x / config.reader.maxZoom, y: y / config.reader.maxZoom});
    useTool().addHistory(history, x, y);
    useTool().saveDrawing(targetPageNum, ctx, history);
    history = [];

    //canvas element id format looks like: tool-canvas-left-0 or tool-canvas-right-1.
    if (targetPageNum % 2 === 1) {
        canvasEl.toBlob((blob) => {
            rightCanvasData.value[targetPageNum] = blob;
            toolState.isRightPageUpdated = true;
        });
    }

    setBodyPinchZoomOnly();
    toolState.isUsing = false;

}

//TODO: move to common method, don't repeat!
const onMouseOut = (e) => {
    checkIsOutOfCanvas(e, onMouseUp);
}


const onMouseMove = (e) => {

    if (isMultiTouch(e)) {
        return;
    }

    e.stopPropagation();
    let offsetValue =  getTouchOffset(e);
    let x = offsetValue.x;
    let y = offsetValue.y;

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    restoreTmpCanvasData(ctx);
    ctx.beginPath();
    ctx.moveTo(startX, startY);
    drawArrow(ctx, startX, startY, x, y);
    ctx.stroke();

}

const drawArrow = (ctx, x, y, x2, y2) => {
    ctx.save();
    let dx = (x2 - x), dy = (y2 - y), len = Math.sqrt(dx * dx + dy * dy),
        rot = Math.atan2(dy, dx), size = ctx.lineWidth * config.reader.maxZoom;
    dx = dy = undefined;


    //Set arrow length
    ctx.translate(x, y);
    ctx.moveTo(0, 0);
    ctx.rotate(rot);
    ctx.lineTo(len, 0);

    //Set left arrow head
    ctx.translate(len, 0);
    ctx.moveTo(0, 0);
    ctx.rotate(7 * Math.PI / 6);
    ctx.lineTo(60, 0);

    //Set right arrow head
    ctx.translate(0, 0);
    ctx.moveTo(0, 0);
    ctx.rotate(5 * Math.PI / 3);
    ctx.lineTo(60, 0);
    ctx.restore();
}


const restoreHistory = (ctx, data) => {

    console.log("arrow restore")

    //Somehow maybe only one point after mouse up, Check to see if at least two points exist in order to restore
    if (data.points.length > 1) {
        let rgba = argbHex2rgbaArr(data.color);
        let startX = data.points[0].x * config.reader.maxZoom;
        let startY = data.points[0].y * config.reader.maxZoom;
        let endX = data.points[1].x * config.reader.maxZoom;
        let endY = data.points[1].y * config.reader.maxZoom;

        ctx.globalCompositeOperation = "source-over";
        ctx.lineJoin = "round";
        ctx.lineCap = "round";
        ctx.lineWidth = data.size * config.reader.maxZoom;
        ctx.setLineDash([]);
        ctx.strokeStyle = updateRgbaStrOpacity(rgbaArr2Str(rgba), rgba[3]);
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        drawArrow(ctx, startX, startY, endX, endY);
        ctx.stroke();
        ctx.closePath();
    }

}

export{
    init,
    activate,
    deactivate,
    onMouseDown,
    onMouseMove,
    onMouseUp,
    restoreHistory
}